import React, { useContext } from "react";
import useTheme from "./useTheme";
var TextStyleContext = /*#__PURE__*/React.createContext();
export var TextStyleProvider = TextStyleContext.Provider;

function useTextStyle() {
  var theme = useTheme();
  var textStyle = useContext(TextStyleContext);
  return {
    textStyle: textStyle,
    textStyleCSS: theme.getTextStyleCSS(textStyle)
  };
}

export default useTextStyle;